import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import type {SignInWithEmailData} from '../ports/auth.repository';

const signInWithEmailDataSchema = z.object({
  email: z.string().trim().min(1, 'Email is required.').email('Enter a valid email address.'),
  password: z.string().min(1, 'Password is required.'),
});

export class SignInWithEmailDataValidator implements Validator<SignInWithEmailData> {
  readonly standardSchema = signInWithEmailDataSchema;

  validate(value: unknown): Result<SignInWithEmailData, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid sign-in payload.'),
      );
    }

    return ok(parsed.data);
  }
}
